var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorklistStatusInProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17144_32268)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_17144_32268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7.6389C14.5025 8.59214 14.2798 9.53248 13.85 10.3833C13.3404 11.4029 12.557 12.2605 11.5876 12.86C10.6181 13.4596 9.50094 13.7773 8.3611 13.7778C7.40786 13.7803 6.46752 13.5576 5.61666 13.1278L1.5 14.5L2.87222 10.3833C2.44245 9.53248 2.21974 8.59214 2.22222 7.6389C2.22266 6.49906 2.54044 5.38185 3.13996 4.41241C3.73948 3.44298 4.59707 2.6596 5.61666 2.15002C6.46752 1.72025 7.40786 1.49754 8.3611 1.50002H8.72221C10.2276 1.58307 11.6494 2.21846 12.7155 3.28453C13.7815 4.3506 14.4169 5.77243 14.5 7.27779V7.6389Z",
    fill: "#0E7016",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17144_32268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_17144_32268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorklistStatusInProgress);
export default __webpack_public_path__ + "static/media/worklist-status-in-progress.b9e6cc37eef7b9b834e8f55786942a7b.svg";
export { ForwardRef as ReactComponent };